module.exports = __webpack_public_path__ + "static/aboutus-banner-66ed3f666c77af3fe2b3ae6d7160976e.jpg";